import { useMemo } from "react";
import {
  getDistanceFromTrendExcelTable,
  useAssetClassSummaryStat,
} from "@app/pages/assetClassAnalysis/useAssetClassSummaryStat";
import { useExcelExport } from "@app/hooks/useExcelExport";
import { useSimulationAssetClassSelector } from "./useSimulationAssetClassSelector";
import { AssetClassLoadType } from "@app/features/assets/useAssetClasses";

export const useSimulationDistanceFromTrend = (params: {
  simulationJobId: string;
}) => {
  const excelExport = useExcelExport();
  const assetClassSelector = useSimulationAssetClassSelector({
    storageKey: "useSimulationDistanceFromTrend_assetClassCode",
    simulationJobId: params.simulationJobId,
  });

  const assetClassAnalysis = useAssetClassSummaryStat({
    type: AssetClassLoadType.bySimulationJobId,
    simulationJobId: params.simulationJobId,
  });

  return useMemo(() => {
    const selectedAssetClass = assetClassSelector.selectedItem;

    const dftItem = assetClassAnalysis.dftItems.find(
      (i) => i.level4Id === selectedAssetClass?.level4Id,
    );

    const handleDownloadReports = () => {
      if (!dftItem) {
        return;
      }
      excelExport.exportAllExcel({
        fileName: `Simulation Distance From Trend - ${selectedAssetClass?.name}`,
        tables: [
          getDistanceFromTrendExcelTable({
            name: selectedAssetClass?.name ?? "",
            item: dftItem,
          }),
        ],
      });
    };

    return {
      isLoading: assetClassAnalysis.isLoading,
      assetClasses: assetClassSelector,
      dftItem,
      assetClassSelector,
      handleDownloadReports,
    };
  }, [
    assetClassAnalysis.dftItems,
    assetClassAnalysis.isLoading,
    assetClassSelector,
    excelExport,
  ]);
};
